module.exports = require("@aws-sdk/client-codecommit");